import { ApiConnector, DELETE, GET, POST, PUT } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/cities');
    const APIV2 = ApiConnector('/cities', true);
    return {
        CitiesList: async (data, query) => await APIV2(GET, '', false, query).call(data),
        CitiesCount: async data => await APIV2(GET, '/count', false).call(data),
        AddCity: async (data, query) => await API(POST, '', false, query).call(data),
        EditCity: async (data, query) => {
            return await APIV2(PUT, '', false, query).call(data);
        },
        DeleteCity: async (data, query) => await API(DELETE, '', false, query).call(data),
        SingleCity: async (data, query) => await API(GET, '/single', false, query).call(data),
        GetCitiesStat: async (data, query) => await API(GET, '/stat', false, query).call(data),
        RelocateCitiesAvaliable: async (data, query) => await API(GET, '/relocate', false, query).call(data),
        GetCurrentPrice: async () => await APIV2(GET, '/avg-price').call(),
        ChangeBlockDay: async data => await API(POST, '/block-day').call(data),
        GetBlockDay: async () => await API(GET, '/block-day').call(),
        ChangeCityPrice: async data => await APIV2(POST, '/avg-price').call(data, true),
        GetCurrentLiPrice: async () => await APIV2(GET, '/avg-price-li').call(),
        ChangeCityLiPrice: async data => await APIV2(POST, '/avg-price-li').call(data, true),
        PostFranchPriceOnline: async data => await APIV2(POST, '/avg-price-online').call(data, true),
        PostFranchPriceOnlineLi: async data => await APIV2(POST, '/avg-price-li-online').call(data, true),
        GetFranchPriceOnline: async data => await APIV2(GET, '/avg-price-online').call(data),
        GetFranchPriceOnlineLi: async data => await APIV2(GET, '/avg-price-li-online').call(data),
        GetAvailableFranchises: async (data, query) => APIV2(GET, '/select/user', false, query).call(data),
        GetCurrentCubePrice: async () => await APIV2(GET, '/avg-price-cube').call(),
        ChangeCityCubePrice: async data => await APIV2(POST, '/avg-price-cube').call(data, true),
        GetCurrentCubeOnlinePrice: async () => await APIV2(GET, '/avg-price-cube-online').call(),
        ChangeCubeOnlinePrice: async data => await APIV2(POST, '/avg-price-cube-online').call(data, true),
    };
})();
